/**
 * Filter chips of the /projects and /library lists. The server filters
 * (`myLibraries(origin, expired)`, `myProjects(expired)`), so the list pages
 * correctly; every chip but "Expirados" lists active videos.
 */
export type ListFilter = 'all' | 'uploaded' | 'community' | 'expired';
export type ListPageType = 'library' | 'project';

export interface ListFilterChip {
  key: ListFilter;
  /** null until the totals arrive. */
  count: number | null;
}

const PAGE_FILTERS: Record<ListPageType, ListFilter[]> = {
  library: ['all', 'uploaded', 'community', 'expired'],
  project: ['all', 'expired'],
};

export function listFilterVariables(
  filter: ListFilter,
): { origin?: 'uploaded' | 'community'; expired: boolean } {
  if (filter === 'expired') return { expired: true };
  if (filter === 'uploaded' || filter === 'community') return { origin: filter, expired: false };
  return { expired: false };
}

export function buildLibraryFilterChips(
  counts: { active_uploaded: number; active_community: number; expired: number } | null | undefined,
): ListFilterChip[] {
  return [
    { key: 'all', count: counts ? counts.active_uploaded + counts.active_community : null },
    { key: 'uploaded', count: counts ? counts.active_uploaded : null },
    { key: 'community', count: counts ? counts.active_community : null },
    { key: 'expired', count: counts ? counts.expired : null },
  ];
}

export function buildProjectFilterChips(
  counts: { active: number; expired: number } | null | undefined,
): ListFilterChip[] {
  return [
    { key: 'all', count: counts ? counts.active : null },
    { key: 'expired', count: counts ? counts.expired : null },
  ];
}

/** The chip in the URL (`?filter=`), when the page has it; else "Todos". */
export function parseListFilter(value: string | null, page: ListPageType): ListFilter {
  const filters = PAGE_FILTERS[page];
  return filters.includes(value as ListFilter) ? (value as ListFilter) : 'all';
}
